// extracted by mini-css-extract-plugin
export var avatar = "_pe-3";
export var avatarContainer = "_pe-2";
export var avatarSpacer = "_pe-5";
export var avatarSpacerContainer = "_pe-4";
export var avatarStackContainer = "_pe-1";
export var bubble = "_pe-0";
export var remainderBubble = "_pe-6";